/*
    eslint-disable max-statements,
    no-magic-numbers,
    max-len,
    no-negated-condition,
    no-unused-vars,
    radix,
    sonarjs/cognitive-complexity,
*/
import { getCookie, setCookie } from "./utils/cookie";

const $ = jQuery.noConflict();

export default function exposedPopup() {
    const popupComponent = document.querySelector(".p-exposed-popup");

    if (popupComponent) {
        let email = "";

        const popupCookie = getCookie("exposed-popup-closed");
        const form = popupComponent.querySelector(".p-exposed-popup__form");
        const cacheDuration = popupComponent.dataset.cacheDuration || 12;
        const scrollPosition = popupComponent.dataset.startPosition || 300;


        if (!popupCookie) {
            let scrolling = false;
            let popupOpened = false;

            window.addEventListener("scroll", event => {
                scrolling = true;
            });

            setInterval(() => {
                if (scrolling && !popupOpened) {
                    scrolling = false;

                    const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

                    if ( scrollTop > Number.parseInt(scrollPosition)) {
                        $.fancybox.open({
                            src  : "#p-exposed-popup",
                            type : "inline",

                            opts : {
                                afterShow( instance, current ) {
                                    //
                                },

                                afterClose( instance, current ) {
                                    setCookie("exposed-popup-closed", true, cacheDuration);
                                },

                                baseClass: "fancybox--exposed-popup",
                            }
                        });
                        popupOpened = true;
                    }
                }
            }, 200);
        }


        form.addEventListener("form-submit", event => {
            const formElement = event.detail.el;

            email = formElement.querySelector('.hs-input[type="email"]').value;
        });

        form.addEventListener("form-submitted", event => {
            const formElement = event.detail.el;
            const url = `${formElement.dataset.redirectUrl}?email=${email}`;

            setCookie("exposed-popup-closed", true, cacheDuration);
            window.location.href = url;
        });
    }
}
